"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
* Represents codename of Kentico Cloud element types
*/
var ElementType;
(function (ElementType) {
    ElementType["Text"] = "text";
    ElementType["Number"] = "number";
    ElementType["ModularContent"] = "modular_content";
    ElementType["Asset"] = "asset";
    ElementType["DateTime"] = "date_time";
    ElementType["RichText"] = "rich_text";
    ElementType["MultipleChoice"] = "multiple_choice";
    ElementType["UrlSlug"] = "url_slug";
    ElementType["Taxonomy"] = "taxonomy";
    ElementType["Custom"] = "custom";
    ElementType["Unknown"] = "unknown";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
//# sourceMappingURL=element-type.js.map


// WEBPACK FOOTER //
// ./node_modules/kentico-cloud-delivery/_commonjs/elements/element-type.js